import { Promise } from "core-js";
import {
  Socket
} from "phoenix";
import {
  globalData
} from "@/providers/global";
import ch from "./Channel";


let socketConn = null;

const _connect = () => {
  console.log("on socket connect");
  disconnect();
  return new Promise((resolve) => {
    const wsURL = globalData.$data.$wsUrl + "/socket";
    socketConn = new Socket(wsURL, {params: {}})
    socketConn.connect()
    resolve(socketConn);
  });
};

const disconnect = () => {
  if (!socketConn) {
    return;
  }

  ch.leave();

  socketConn.disconnect();
  socketConn = null;
  console.log("socket disconnected...");
};

export default {
  async connect() {
    return new Promise((resolve, reject) => {
      _connect().then((conn) => {
        console.log("socket connection created", {conn})
        resolve(conn);
      }).catch((e) => {
        console.log("invalid socket connection", e)
        reject("invalid ws connection")
      });
    });
  },
  disconnect,
  connectCh(callbackFns, storeId, klStoreId, klId) {
    if (!socketConn || socketConn.conn.readyState !== 1) {
      _connect().then((conn) => {
        console.log("socket connection created", { conn })
        ch.join(conn, callbackFns, storeId, klStoreId, klId);
      }).catch((e) => {
        console.log("invalid socket connection", e)
      });
    } else {
      ch.join(socketConn, callbackFns, storeId, klStoreId, klId);
    }
  }
};
